var map = {
	"./1475BEC8.png": "b950",
	"./1475BECB.png": "6d72",
	"./4196C921.png": "f90d",
	"./5C5FA846.png": "62fa",
	"./5C7F1583.png": "7e75",
	"./73ABC14D.png": "469f",
	"./AB66C82C.png": "1ba2",
	"./D1DF0471.png": "fec6",
	"./FF1BCEE.png": "eb22",
	"./abm.png": "db68",
	"./abm.svg": "0853",
	"./aci.png": "065c",
	"./aci.svg": "98ec",
	"./banbajio.png": "9e0c",
	"./banbajio.svg": "8faa",
	"./banco-de-mexico.png": "2246",
	"./banco-de-mexico.svg": "c6a5",
	"./bancoazteca.png": "fe28",
	"./bancoazteca.svg": "0af2",
	"./banorte.gif": "9834",
	"./banorte.png": "40a6",
	"./banorte.svg": "719b",
	"./bbdo.png": "f605",
	"./bbdo.svg": "f84c",
	"./bbva.png": "2496",
	"./bbva.svg": "8b2c",
	"./cnbv.png": "ba84",
	"./cnbv.svg": "4481",
	"./deloitte.png": "c477",
	"./deloitte.svg": "2be4",
	"./google-cloud.png": "0ef6",
	"./google-cloud.svg": "73f4",
	"./heybanco.png": "93ee",
	"./heybanco.svg": "68bf",
	"./hsbc.png": "d438",
	"./hsbc.svg": "d8f6",
	"./humanbe.png": "ae29",
	"./humanbe.svg": "7080",
	"./illumio.png": "ed8c",
	"./illumio.svg": "66ea",
	"./ingenico.png": "1ddf",
	"./ingenico.svg": "2ca1",
	"./invex.png": "aa8e",
	"./invex.svg": "63e2",
	"./multiva.png": "c619",
	"./multiva.svg": "edac",
	"./newland.png": "e7a9",
	"./newland.svg": "2c2a",
	"./pcmi.png": "8fda",
	"./pcmi.svg": "c186",
	"./prosa.png": "506e",
	"./prosa.svg": "9b8f",
	"./syncfy.png": "05a9",
	"./syncfy.svg": "71eb",
	"./vierge-group.png": "c8ad",
	"./vierge-group.svg": "2ea4",
	"./white-security.png": "0f4d",
	"./white-security.svg": "6afd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67fa";